import { Typography } from '@mui/material';
import * as React from 'react';
import { PrimaryLightBgCard, WhiteBgCard } from 'components';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useSelector } from 'react-redux';
import { selectAuthUser } from 'base/auth/selectors';

const Statistics = () => {
  const authUser = useSelector(selectAuthUser);
  const { statistics } = authUser.attributes;

  return (
    <WhiteBgCard sx={{ mb: 3 }}>
      <div className="row align-items-center mb-4">
        <div className="col d-none d-md-block">
          <Typography className="lh-1" variant="h6">
            Statistics
          </Typography>
        </div>
        <div className="col d-block d-md-none">
          <Typography className="lh-1" variant="h5">
            Statistics
          </Typography>
        </div>
        <div className="col-auto">
          <div className="custom-swiper-pagination statistics-swiper-pagination d-flex justify-content-center align-items-center text-center" />
        </div>
      </div>

      <Swiper
        modules={[Pagination]}
        spaceBetween={24}
        slidesPerView={2}
        pagination={{
          el: '.statistics-swiper-pagination',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className}"></span>`;
          },
        }}
      >

        {statistics && statistics.length > 0 ? statistics.map((data) => (
          <SwiperSlide key={data.title}>
            <PrimaryLightBgCard>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
                {data.title}
              </Typography>
              <Typography variant="body2">
                {data.description}
              </Typography>
            </PrimaryLightBgCard>
          </SwiperSlide>
        )) : (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            There are no statistics added
          </Typography>
        )}

      </Swiper>

    </WhiteBgCard>
  );
};

export default Statistics;
